/* assets/price-slider.js */
(function () {
  const ENHANCED_ATTR = 'data-price-slider-enhanced';

  // Intl currency formatter (falls back to GBP)
  function currencyFormatter() {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    } catch (e) {
      return { format(v) { return '£' + Number(v).toFixed(2); } };
    }
  }
  const fmt = currencyFormatter();

  const clamp = (n, min, max) => Math.max(min, Math.min(n, max));
  const roundInt = (n) => Math.round(Number(n) || 0);

  // Simple debounce for form auto-submit
  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function initOne(root) {
    if (!root || root.getAttribute(ENHANCED_ATTR) === 'true') return;
    root.setAttribute(ENHANCED_ATTR, 'true');

    // ORIGINAL UNITS (no cents)
    let rangeMax = parseFloat(root.dataset.rangeMax);
    if (!isFinite(rangeMax) || rangeMax <= 0) rangeMax = 100;

    let minVal = parseFloat(root.dataset.minInitial);
    let maxVal = parseFloat(root.dataset.maxInitial);
    if (!isFinite(minVal)) minVal = 0;
    if (!isFinite(maxVal) || maxVal <= 0) maxVal = rangeMax;

    // Elements
    const slider   = root.querySelector('[data-slider]');
    const rangeEl  = root.querySelector('[data-slider-range]');
    const thumbMin = root.querySelector('[data-thumb="min"]');
    const thumbMax = root.querySelector('[data-thumb="max"]');
    const numberMin = root.querySelector('[data-number-min]');
    const numberMax = root.querySelector('[data-number-max]');
    const hiddenMin = root.querySelector('[data-hidden-min]');
    const hiddenMax = root.querySelector('[data-hidden-max]');
    const minLabel = root.querySelector('[data-price-min-label]');
    const maxLabel = root.querySelector('[data-price-max-label]');

    if (!slider || !rangeEl || !thumbMin || !thumbMax) return;

    const valueToPercent = (v) => (v / rangeMax) * 100;
    const percentToValue = (p) => (p / 100) * rangeMax;
    const trackRect = () => slider.getBoundingClientRect();

    // Find the surrounding form Dawn uses
    const form = root.closest('form');

    // Debounced notify to Dawn's facets.js (it listens to 'input' on the form)
    const notifyFacets = debounce(() => {
      if (!form) return;
      const evt = new Event('input', { bubbles: true });
      form.dispatchEvent(evt);
    }, 250);

    function updateHidden() {
      // Disable hidden inputs when they represent the full range so Dawn omits them
      const minDisabled = minVal <= 0;
      const maxDisabled = Math.ceil(maxVal) >= Math.ceil(rangeMax);

      if (hiddenMin) {
        hiddenMin.value = minDisabled ? '' : String(Math.floor(minVal));
        hiddenMin.disabled = minDisabled;
      }
      if (hiddenMax) {
        hiddenMax.value = maxDisabled ? '' : String(Math.ceil(maxVal));
        hiddenMax.disabled = maxDisabled;
      }
    }

    function render() {
      // Keep whole numbers only (no decimals)
      minVal = roundInt(minVal);
      maxVal = roundInt(maxVal);

      // Labels
      if (minLabel) minLabel.textContent = fmt.format(minVal);
      if (maxLabel) maxLabel.textContent = fmt.format(maxVal);

      // Positions (overwrite any stale inline styles after AJAX)
      const pMin = clamp(valueToPercent(minVal), 0, 100);
      const pMax = clamp(valueToPercent(maxVal), 0, 100);
      rangeEl.style.left  = pMin + '%';
      rangeEl.style.right = (100 - pMax) + '%';
      thumbMin.style.left = pMin + '%';
      thumbMax.style.left = pMax + '%';

      // a11y
      thumbMin.setAttribute('aria-valuemin', '0');
      thumbMin.setAttribute('aria-valuemax', String(rangeMax));
      thumbMin.setAttribute('aria-valuenow', String(minVal));
      thumbMax.setAttribute('aria-valuemin', '0');
      thumbMax.setAttribute('aria-valuemax', String(rangeMax));
      thumbMax.setAttribute('aria-valuenow', String(maxVal));

      // Inputs (whole numbers)
      if (numberMin) numberMin.value = Math.floor(minVal);
      if (numberMax) numberMax.value = Math.ceil(maxVal);

      // Hidden inputs that the form submits
      updateHidden();
    }

    function startDrag(e, which) {
      e.preventDefault();
      const rect = trackRect();
      if (!rect || !rect.width) return;

      const onMove = (ev) => {
        const clientX = ev.touches ? ev.touches[0].clientX : ev.clientX;
        let pct = ((clientX - rect.left) / rect.width) * 100;
        pct = clamp(pct, 0, 100);
        const val = roundInt(percentToValue(pct));

        if (which === 'min') {
          minVal = clamp(val, 0, maxVal);
        } else {
          maxVal = clamp(val, minVal, rangeMax);
        }
        render();
        notifyFacets(); // auto-apply while dragging (debounced)
      };

      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('touchend', onUp);
        // one last notify to ensure final value is applied immediately
        if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('mouseup', onUp);
      document.addEventListener('touchend', onUp);
    }

    // Bind drag
    thumbMin.addEventListener('mousedown', (e) => startDrag(e, 'min'));
    thumbMax.addEventListener('mousedown', (e) => startDrag(e, 'max'));
    thumbMin.addEventListener('touchstart', (e) => startDrag(e, 'min'), { passive: false });
    thumbMax.addEventListener('touchstart', (e) => startDrag(e, 'max'), { passive: false });

    // Number inputs
    if (numberMin) {
      numberMin.step = '1';
      numberMin.addEventListener('change', () => {
        const v = roundInt(numberMin.value);
        if (isFinite(v)) {
          minVal = clamp(v, 0, maxVal);
          render();
          if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }
    if (numberMax) {
      numberMax.step = '1';
      numberMax.addEventListener('change', () => {
        const v = roundInt(numberMax.value);
        if (isFinite(v)) {
          maxVal = clamp(v, minVal, rangeMax);
          render();
          if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }

    // Initial paint — after layout to avoid overlap on AJAX render
    requestAnimationFrame(() => {
      // Re-parse in case section render updated data-*
      const rMax = parseFloat(root.dataset.rangeMax);
      if (isFinite(rMax) && rMax > 0) rangeMax = rMax;

      const minInit = parseFloat(root.dataset.minInitial);
      const maxInit = parseFloat(root.dataset.maxInitial);
      if (isFinite(minInit)) minVal = clamp(roundInt(minInit), 0, isFinite(maxInit) ? roundInt(maxInit) : roundInt(rangeMax));
      if (isFinite(maxInit)) maxVal = clamp(roundInt(maxInit), roundInt(minVal), roundInt(rangeMax));

      render();
    });
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-price-slider]').forEach(initOne);
  }

  // Initial
  document.addEventListener('DOMContentLoaded', () => initAll());

  // Shopify section lifecycle
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:select', (e) => initAll(e.target));

  // Keep your MutationObserver to re-init after Dawn facets AJAX replaces DOM
  const filtersHost = document.getElementById('main-collection-filters');
  if (filtersHost) {
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
          initAll(filtersHost);
        }
        if (m.type === 'attributes' && m.target && m.target.matches('[data-price-slider]')) {
          initAll(filtersHost);
        }
      }
    });
    mo.observe(filtersHost, { childList: true, subtree: true, attributes: true });
  }
})();
